import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjouteParametragePromo = async (data) => {
  return await axios.post(`${BASE_URL}/api/restaurant/ajouteCreneauPromo`, data, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}
const AfficheService = async (idRestaurant) => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheService/${idRestaurant}`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}
const AfficheParametragePromo = async (idRestaurant) => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheParametragePromo/${idRestaurant}`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}


const AjouteSansOffre = async (data) => {
  return await axios.post(`${BASE_URL}/api/restaurant/ajouteParametrageOffre`, data, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}

const AfficheSansOffre = async (idRestaurant) => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheParametrageOffre/${idRestaurant}`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}

const AffichePromoMinOffre = async () => {
    return await axios.get(`${BASE_URL}/api/societe/affichePromotionMin`, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}


export { AfficheService, AjouteParametragePromo, AfficheParametragePromo, AjouteSansOffre, AfficheSansOffre,AffichePromoMinOffre }